import { useState, useEffect } from 'react'
import { apiService } from '../services/api'

export const useProposalStatuses = () => {
 const [statuses, setStatuses] = useState<Array<{ value: string; label: string }>>([])
 const [isLoading, setIsLoading] = useState(true)
 const [error, setError] = useState<string | null>(null)

 const fetchStatuses = async () => {
 try {
 setIsLoading(true)
 setError(null)
 const response = await apiService.getProposalStatuses()
 setStatuses(Array.isArray(response) ? response : [])
 } catch (err) {
 console.error('Erro ao carregar status de propostas:', err)
 setError('Erro ao carregar status de propostas. Tente novamente.')
 setStatuses([])
 } finally {
 setIsLoading(false)
 }
 }

 useEffect(() => {
 fetchStatuses()
 }, [])

 return {
 statuses,
 isLoading,
 error,
 refetch: fetchStatuses
 }
}

